import styled from '@emotion/styled';
import { ButtonBase } from '@mui/material';

export const NavigationButton = styled(ButtonBase, {
    shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean; disabled?: boolean }>`
    padding: 16px;
    height: 56px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: start;
    background-color: ${({ theme, active }) => (active ? theme.colors.black[100] : 'transparent')};
    gap: 14px;
    white-space: nowrap;

    color: ${({ theme, active }) => (active ? theme.colors.secondary[900] : theme.colors.secondary[700])};
    font-size: 14px;
    font-weight: 600;

    :hover {
        background-color: ${({ theme }) => theme.colors.black[100]};
        color: ${({ theme }) => theme.colors.secondary[900]};
    }

    &:disabled {
        color: ${({ theme }) => theme.colors.secondary[300]};
    }
`;
